import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import get from 'lodash/get.js';
import groupBy from 'lodash/groupBy.js';
import some from 'lodash/some.js';

function isProductOption(option) {
  return ['page', 'feature', 'poll', 'guide'].includes(option.type);
}
function getOptionIconType(option) {
  if (isProductOption(option)) {
    return option.type;
  }
  return option.kind === 'replay' ? 'play-circle' : option.kind;
}
function getResourceOptions(resources, field) {
  return resources.filter(resource => {
    if (field === 'guideId') {
      const isResourceCenter = get(resource, 'attributes.resourceCenter') && resource.state !== 'public';
      return !isResourceCenter;
    }
    return true;
  }).map(resource => {
    if (field === 'guideId') {
      return _objectSpread2(_objectSpread2({}, resource), {}, {
        [field]: resource.id,
        guideStepId: get(resource, 'steps[0].id')
      });
    }
    return {
      [field]: resource.id,
      name: resource.name,
      group: {
        color: get(resource.group, 'color'),
        name: get(resource.group, 'name')
      }
    };
  });
}
function getFactOptionsForType(type) {
  return {
    feature: [{
      fact: 'eventCount',
      label: 'Number of Clicks'
    }, {
      fact: 'daysActive',
      label: 'Number of Days Active'
    }],
    page: [{
      fact: 'eventCount',
      label: 'Number of Page Views'
    }, {
      fact: 'daysActive',
      label: 'Number of Days Active'
    }, {
      fact: 'eventTime',
      label: 'Time On Page (minutes)'
    }],
    guide: [{
      fact: 'guideViews',
      label: 'Number of Guide Views'
    }]
  }[type];
}
function getAvailableColumns(options) {
  return options.map(option => {
    const iconType = getOptionIconType(option);
    return _objectSpread2(_objectSpread2({}, option), {}, {
      icon: {
        type: iconType,
        size: 14
      }
    });
  });
}
function groupOptionsByKind(options) {
  const groups = {
    replay: 'Replay Data',
    productUsage: 'Product Usage',
    visitor: 'Visitor Data',
    account: 'Account Data',
    parentAccount: 'Parent Account Data'
  };
  const groupedOptions = groupBy(options, option => {
    if (isProductOption(option)) {
      return 'productUsage';
    }
    return option.kind;
  });
  return Object.keys(groups).reduce((acc, group) => {
    const options = groupedOptions[group];
    if (!options) {
      return acc;
    }
    acc.push({
      label: groups[group],
      id: group,
      options
    });
    return acc;
  }, []);
}
function getHasPolls(guide) {
  return some(guide.steps, step => step.pollIds && step.pollIds.length);
}

export { getAvailableColumns, getFactOptionsForType, getHasPolls, getOptionIconType, getResourceOptions, groupOptionsByKind, isProductOption };
//# sourceMappingURL=utils.js.map
